import { StyleSheet, View } from '@react-pdf/renderer';
import React from "react";
import { Dashboard, DashboardQuery } from "../../../types/files";
import PDFDealOwner from './queries/PDFDealOwner';
import PDFDealSource from './queries/PDFDealSource';
import PDFDigestQuery from './queries/PDFDigestQuery';
import PDFFoundedQuery from './queries/PDFFoundedQuery';
import PDFLinkedInQuery from './queries/PDFLinkedInQuery';
import PDFLocationQuery from './queries/PDFLocationQuery';
import PDFWebsiteQuery from './queries/PDFWebsiteQuery';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        paddingVertical: 8,
    },
    col: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        paddingHorizontal: 8,
    },
    row: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    },
});

const PDFDashboardDetails: React.FC<{ dashboard: Dashboard|null, queries: DashboardQuery[] }> = ({ dashboard, queries }) => {
    return (<>
        <View style={styles.container}>
            <View style={[styles.col, { width: '45%' }]}>
                <PDFDigestQuery query={queries.find(({title}) => title === 'Description')} />
                <View style={[styles.col, { width: '100%' }]}>
                    <PDFWebsiteQuery query={queries.find(({title}) => title === 'Website')} />
                    <PDFLinkedInQuery query={queries.find(({title}) => title === 'LinkedIn')} />
                </View>
            </View>
            <View style={[styles.col, { width: '55%' }]}>
                <View style={styles.row}>
                    <View style={{ paddingHorizontal: 8, width: '100%' }}>
                        <PDFLocationQuery query={queries.find(({title}) => title === 'Location')} />
                    </View>
                    <View style={{ paddingHorizontal: 8, width: '100%' }}>
                        <PDFDealOwner dashboard={dashboard!} />
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={{ paddingHorizontal: 8, width: '100%' }}>
                        <PDFFoundedQuery query={queries.find(({title}) => title === 'Founded')} />
                    </View>
                    <View style={{ paddingHorizontal: 8, width: '100%' }}>
                        <PDFDealSource dashboard={dashboard!} />
                    </View>
                </View>
            </View>
        </View>
    </>);
}

export default PDFDashboardDetails;